var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 111.25,
    height: 47.291,
    viewBox: "0 0 111.25 47.291",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iotfig_logo",
    "data-name": "iotfig logo",
    transform: "translate(-0.005 -0.031)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M43.742,52.164c-2.029,5.089-7,8.631-12.121,10.212a31.737,31.737,0,0,1-12.241,1.1A37.736,37.736,0,0,1,11.8,61.963a15.14,15.14,0,0,1-3.2-1.393A17.2,17.2,0,0,1,.709,50.84c-2.046-6.464.585-13.771,5.089-18.585,3.249-3.473,7.5-5.6,11.467-8.1A45.217,45.217,0,0,0,22.922,20.1a4.168,4.168,0,0,0,.877,1.255,2.851,2.851,0,0,0,2.373.86,3.655,3.655,0,0,0,.877-.223l.155-.052a4.23,4.23,0,0,0,1.685,3.92,14.7,14.7,0,0,0,2.338,1.289c5.57,2.734,10.9,7.324,13,13.324.052.172.12.327.172.5,1.668,5.364-.653,11.175-.653,11.192",
    transform: "translate(0 -16.619)",
    fill: "#702f88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M58.165,28.252c-.017-.223-1.994-.928-2.269-1.066a.761.761,0,0,0-.258-.086.639.639,0,0,0-.378.172c-7.186,5.57-15.989,12.808-16.866,22.384a14.873,14.873,0,0,0,.292,5.656,16.407,16.407,0,0,0,5.828,8.923,19.071,19.071,0,0,0,4.229,2.51A20.681,20.681,0,0,0,65.7,66.058c5.5-2.7,10.006-6.86,9.92-13.221C75.529,45.066,70.3,38.069,63.6,33.977c-2.338-1.375-5.312-2.7-5.433-5.725",
    transform: "translate(-31.668 -22.415)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M41.776,122.618a.515.515,0,0,0-.069.138c-.034.052-.052.1-.086.155-.1.206-.223.413-.344.619a6.952,6.952,0,0,1-.4.585c-.138.189-.292.361-.447.55s-.327.361-.5.55a6.819,6.819,0,0,1-.5.5c-.292.275-.585.533-.877.791-.309.258-.619.481-.928.7-.327.224-.653.447-.98.636-.344.206-.688.4-1.032.585q-.542.284-1.083.516a3.2,3.2,0,0,1-.43.172,27.439,27.439,0,0,1-8.166,1.908,31.745,31.745,0,0,1-15.576-2.218A17.245,17.245,0,0,1,.05,114.5a17.708,17.708,0,0,1,.017-2.338,21.206,21.206,0,0,1,.825-4.5q.206-.619.464-1.238a22.635,22.635,0,0,1,.98-2.063c.017-.017.017-.034.034-.052A28.54,28.54,0,0,1,4.262,101.3a36.311,36.311,0,0,0-.963,4.04,19.915,19.915,0,0,0,.464,9.61c1.049,3.215,2.613,10.229,12.963,13.582,5.364,1.736,13.358,1.719,18.413-.825a22.3,22.3,0,0,0,6.636-5.089",
    transform: "translate(-0.011 -83.859)",
    fill: "#5f2b7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M138.389,3.859s-1.891.481-2.2,1.84a1.767,1.767,0,0,1-1.358,1.393,1.4,1.4,0,0,1-.653-.086,3.715,3.715,0,0,1-1.994-1.289,2.335,2.335,0,0,1-.241-1.994s.172-.653,1.685-1.771c0,0,3.232-2.269,5.244-1.874,0,0,2.63,1.84,1.117,3.129,0-.017-1.513.619-1.6.653",
    transform: "translate(-109.158 0)",
    fill: "#8abe40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M161.9,10.3a5.189,5.189,0,0,0,.6.774,3.071,3.071,0,0,0,.739.6,1.4,1.4,0,0,0,.911.189,2.333,2.333,0,0,0,.911-.327,1.743,1.743,0,0,1-.877.464,1.533,1.533,0,0,1-1-.172,2.366,2.366,0,0,1-.756-.67,2.99,2.99,0,0,1-.533-.86",
    transform: "translate(-134.061 -8.504)",
    fill: "#516931"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M191.349,89.978a1.043,1.043,0,0,1-1.066,1.083,1.183,1.183,0,0,1-1.083-1.186,1.038,1.038,0,0,1,1.083-1.083,1.182,1.182,0,0,1,1.066,1.186",
    transform: "translate(-156.668 -73.499)",
    fill: "#5f2b7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M193.038,92.367a.6.6,0,0,1-.619.619.674.674,0,0,1-.619-.671.606.606,0,0,1,.619-.619.651.651,0,0,1,.619.671",
    transform: "translate(-158.821 -75.906)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M225.246,158.517a1.027,1.027,0,1,1-1.014-1.117,1.075,1.075,0,0,1,1.014,1.117",
    transform: "translate(-184.822 -130.314)",
    fill: "#5f2b7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M226.969,160.836a.614.614,0,0,1-.585.636.638.638,0,0,1,0-1.272.615.615,0,0,1,.585.636",
    transform: "translate(-186.975 -132.632)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M144.6,70.321a1.079,1.079,0,0,1-1.152,1.1,1.253,1.253,0,0,1-1.152-1.238,1.079,1.079,0,0,1,1.152-1.1,1.253,1.253,0,0,1,1.152,1.238",
    transform: "translate(-117.831 -57.177)",
    fill: "#5f2b7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M146.507,72.8a.628.628,0,0,1-.653.636.711.711,0,0,1-.653-.7.628.628,0,0,1,.653-.636.7.7,0,0,1,.653.7",
    transform: "translate(-120.232 -59.675)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M96.559,101.647a1.172,1.172,0,0,1-1.221,1.169,1.27,1.27,0,0,1-1.238-1.255,1.166,1.166,0,0,1,1.238-1.169,1.255,1.255,0,0,1,1.221,1.255",
    transform: "translate(-77.918 -83.106)",
    fill: "#5f2b7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M98.61,104.119a.669.669,0,0,1-.7.67.735.735,0,0,1-.7-.722.669.669,0,0,1,.7-.671.735.735,0,0,1,.7.722",
    transform: "translate(-80.485 -85.594)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M96.059,186.884a1.252,1.252,0,0,1-1.221,1.238,1.19,1.19,0,0,1-1.238-1.186,1.244,1.244,0,0,1,1.238-1.238,1.186,1.186,0,0,1,1.221,1.186",
    transform: "translate(-77.504 -153.746)",
    fill: "#5f2b7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M98.11,189.367a.708.708,0,0,1-.7.7.669.669,0,0,1-.7-.671.708.708,0,0,1,.7-.7.679.679,0,0,1,.7.671",
    transform: "translate(-80.071 -156.229)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M145.5,242.592a1.24,1.24,0,0,1-1.152,1.238,1.079,1.079,0,0,1-1.152-1.1,1.24,1.24,0,0,1,1.152-1.238,1.079,1.079,0,0,1,1.152,1.1",
    transform: "translate(-118.576 -199.947)",
    fill: "#5f2b7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M147.507,245.032a.711.711,0,0,1-.653.7.618.618,0,0,1-.653-.636.7.7,0,0,1,.653-.7.618.618,0,0,1,.653.636",
    transform: "translate(-121.06 -202.353)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M146.458,129.1a.686.686,0,0,1-.67.688.7.7,0,0,1-.688-.7.69.69,0,0,1,.688-.688.68.68,0,0,1,.67.7",
    transform: "translate(-120.15 -106.3)",
    fill: "#5f2b7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M147.491,130.413a.389.389,0,0,1-.4.4.415.415,0,0,1-.4-.413.389.389,0,0,1,.4-.4.427.427,0,0,1,.4.413",
    transform: "translate(-121.475 -107.624)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M146.358,104.919a.66.66,0,0,1-.671.67.732.732,0,0,1-.688-.722.665.665,0,0,1,.688-.671.717.717,0,0,1,.671.722",
    transform: "translate(-120.067 -86.257)",
    fill: "#5f2b7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M147.491,106.307a.365.365,0,0,1-.4.378.415.415,0,0,1-.4-.413.365.365,0,0,1,.4-.378.442.442,0,0,1,.4.413",
    transform: "translate(-121.475 -87.662)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M137.575,189.288a.732.732,0,0,1-.688.722.669.669,0,0,1-.688-.688.72.72,0,0,1,.688-.722.679.679,0,0,1,.688.688",
    transform: "translate(-112.78 -156.15)",
    fill: "#5f2b7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M138.691,190.8a.415.415,0,0,1-.4.413.389.389,0,0,1-.4-.4.415.415,0,0,1,.4-.413.389.389,0,0,1,.4.4",
    transform: "translate(-114.187 -157.64)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M55.8,157.455a1.292,1.292,0,0,1-1.289,1.255,1.255,1.255,0,1,1,1.289-1.255",
    transform: "translate(-44.049 -129.32)",
    fill: "#5f2b7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M57.979,160.1a.74.74,0,1,1-.739-.7.706.706,0,0,1,.739.7",
    transform: "translate(-46.782 -131.967)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M88.979,160.822a.739.739,0,1,1-.739-.722.73.73,0,0,1,.739.722",
    transform: "translate(-72.452 -132.55)",
    fill: "#5f2b7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M90.325,162.313a.413.413,0,1,1-.413-.413.418.418,0,0,1,.413.413",
    transform: "translate(-74.109 -134.04)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M186.066,157.633a1.084,1.084,0,1,1-1.083-1.135,1.1,1.1,0,0,1,1.083,1.135",
    transform: "translate(-152.279 -129.566)",
    fill: "#5f2b7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M187.838,159.953a.62.62,0,1,1-.619-.653.635.635,0,0,1,.619.653",
    transform: "translate(-154.515 -131.887)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M172.718,124.784a1.116,1.116,0,0,1-1.1,1.135,1.165,1.165,0,0,1-1.118-1.186,1.109,1.109,0,0,1,1.118-1.135,1.174,1.174,0,0,1,1.1,1.186",
    transform: "translate(-141.183 -102.323)",
    fill: "#5f2b7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M174.472,127.167a.614.614,0,0,1-.636.636.665.665,0,0,1-.636-.671.614.614,0,0,1,.636-.636.654.654,0,0,1,.636.67",
    transform: "translate(-143.419 -104.723)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M97.258,230.85a1.294,1.294,0,0,1-1.221,1.272A1.153,1.153,0,0,1,94.8,230.97a1.285,1.285,0,0,1,1.238-1.272,1.168,1.168,0,0,1,1.221,1.152",
    transform: "translate(-78.497 -190.182)",
    fill: "#5f2b7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M99.31,233.45a.734.734,0,0,1-.7.722.656.656,0,0,1-.7-.653.734.734,0,0,1,.7-.722.665.665,0,0,1,.7.653",
    transform: "translate(-81.064 -192.747)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M175.2,217.7a1.2,1.2,0,0,1-1.1,1.2,1.066,1.066,0,0,1-1.1-1.1,1.2,1.2,0,0,1,1.1-1.2,1.066,1.066,0,0,1,1.1,1.1",
    transform: "translate(-143.253 -179.334)",
    fill: "#5f2b7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M177.055,220.036a.678.678,0,0,1-.619.688.614.614,0,0,1-.636-.636.68.68,0,0,1,.636-.688.62.62,0,0,1,.619.636",
    transform: "translate(-145.572 -181.655)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M74.2,105.953a.706.706,0,0,1-.739.7.775.775,0,0,1-.756-.756.71.71,0,0,1,.756-.7.771.771,0,0,1,.739.756",
    transform: "translate(-60.197 -87.085)",
    fill: "#5f2b7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M75.36,107.525a.4.4,0,0,1-.43.4.437.437,0,0,1-.43-.43.4.4,0,0,1,.43-.4.426.426,0,0,1,.43.43",
    transform: "translate(-61.687 -88.656)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M211.2,203.781a1.123,1.123,0,0,1-1.049,1.152,1.04,1.04,0,0,1-1.049-1.083,1.123,1.123,0,0,1,1.049-1.152,1.05,1.05,0,0,1,1.049,1.083",
    transform: "translate(-173.147 -167.823)",
    fill: "#5f2b7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M212.9,206.115a.632.632,0,0,1-.6.653.592.592,0,0,1-.6-.619.633.633,0,0,1,.6-.653.592.592,0,0,1,.6.619",
    transform: "translate(-175.3 -170.141)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M205.738,126.988a.635.635,0,0,1-.619.653.656.656,0,0,1-.619-.688.635.635,0,0,1,.619-.653.667.667,0,0,1,.619.688",
    transform: "translate(-169.337 -104.561)",
    fill: "#5f2b7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M206.622,128.3a.367.367,0,0,1-.361.378.383.383,0,0,1-.361-.4.367.367,0,0,1,.361-.378.394.394,0,0,1,.361.4",
    transform: "translate(-170.497 -105.885)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M115.232,126.316a.5.5,0,0,1-.516.5.529.529,0,0,1-.516-.516.5.5,0,0,1,.516-.5.529.529,0,0,1,.516.516",
    transform: "translate(-94.562 -104.147)",
    fill: "#5f2b7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M116.085,127.392a.292.292,0,1,1-.292-.292.3.3,0,0,1,.292.292",
    transform: "translate(-95.639 -105.223)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M74.066,159.933a.533.533,0,1,1-.533-.533.547.547,0,0,1,.533.533",
    transform: "translate(-60.445 -131.97)",
    fill: "#5f2b7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M74.819,161.092a.294.294,0,0,1-.309.292.3.3,0,0,1-.309-.292.294.294,0,0,1,.309-.292.305.305,0,0,1,.309.292",
    transform: "translate(-61.439 -133.129)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M176.628,162.477a.466.466,0,0,1-.464.481.477.477,0,0,1-.464-.481.465.465,0,1,1,.928,0",
    transform: "translate(-145.489 -134.118)",
    fill: "#5f2b7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M177.35,163.468a.275.275,0,1,1-.275-.275.262.262,0,0,1,.275.275",
    transform: "translate(-146.4 -135.11)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M116.532,160.816a.516.516,0,1,1-.516-.516.541.541,0,0,1,.516.516",
    transform: "translate(-95.639 -132.715)",
    fill: "#5f2b7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M117.385,161.892a.292.292,0,1,1-.292-.292.314.314,0,0,1,.292.292",
    transform: "translate(-96.715 -133.792)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M203.794,196.264a.5.5,0,0,1-.447.5.448.448,0,0,1-.447-.464.5.5,0,0,1,.447-.5.448.448,0,0,1,.447.464",
    transform: "translate(-168.012 -162.112)",
    fill: "#5f2b7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M204.516,197.275a.258.258,0,1,1-.258-.275.268.268,0,0,1,.258.275",
    transform: "translate(-168.923 -163.106)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M123.6,211.1a.542.542,0,0,1-.5.533.478.478,0,0,1-.5-.5.542.542,0,0,1,.5-.533.51.51,0,0,1,.5.5",
    transform: "translate(-101.518 -174.367)",
    fill: "#5f2b7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M124.285,212.175a.29.29,0,0,1-.292.292.286.286,0,0,1-.292-.275.3.3,0,0,1,.292-.292.276.276,0,0,1,.292.275",
    transform: "translate(-102.429 -175.444)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M110.932,221.9a.544.544,0,0,1-.516.533.483.483,0,0,1-.516-.5.532.532,0,0,1,.516-.533.514.514,0,0,1,.516.5",
    transform: "translate(-91.001 -183.311)",
    fill: "#5f2b7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M111.785,223.068a.331.331,0,0,1-.292.309.286.286,0,0,1-.292-.275.331.331,0,0,1,.292-.309.276.276,0,0,1,.292.275",
    transform: "translate(-92.078 -184.463)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M90.472,76.2A17.345,17.345,0,0,0,79.4,81.444",
    transform: "translate(-65.745 -63.074)",
    fill: "none",
    stroke: "#5f2b7a",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M79.745,110.1a12.959,12.959,0,0,0-3.645,8.716",
    transform: "translate(-63.012 -91.146)",
    fill: "none",
    stroke: "#5f2b7a",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M101.4,108.5s-7.805.172-9.2,9.095",
    transform: "translate(-76.344 -89.821)",
    fill: "none",
    stroke: "#5f2b7a",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M157.118,138.023s-.241-4.35-4.418-5.123",
    transform: "translate(-126.443 -110.026)",
    fill: "none",
    stroke: "#5f2b7a",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M207.278,133s2.579,4.487-.378,11.02",
    transform: "translate(-171.325 -110.109)",
    fill: "none",
    stroke: "#5f2b7a",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M199.5,97.8a16.616,16.616,0,0,1,5.055,10.4",
    transform: "translate(-165.197 -80.96)",
    fill: "none",
    stroke: "#5f2b7a",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M66.451,180.081S60.21,175.25,60.3,168.7",
    transform: "translate(-49.924 -139.671)",
    fill: "none",
    stroke: "#5f2b7a",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M107.435,199.82s-2.768-1.427-3.335-2.82",
    transform: "translate(-86.198 -163.106)",
    fill: "none",
    stroke: "#5f2b7a",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M121.653,170.287A5.658,5.658,0,0,1,118.3,165.8",
    transform: "translate(-97.957 -137.27)",
    fill: "none",
    stroke: "#5f2b7a",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M124.967,225.569A11.123,11.123,0,0,1,114.6,225.5",
    transform: "translate(-94.893 -186.706)",
    fill: "none",
    stroke: "#5f2b7a",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    y2: 3.868,
    transform: "translate(25.621 14.209)",
    fill: "none",
    stroke: "#5f2b7a",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    x1: 2.407,
    y2: 4.384,
    transform: "translate(30.899 17.269)",
    fill: "none",
    stroke: "#5f2b7a",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    x1: 1.926,
    y1: 2.441,
    transform: "translate(17.936 19.401)",
    fill: "none",
    stroke: "#5f2b7a",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    x1: 1.1,
    transform: "translate(11.575 27.997)",
    fill: "none",
    stroke: "#5f2b7a",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M156.363,168.4a7.652,7.652,0,0,1-6.963,6.808v6.035",
    transform: "translate(-123.71 -139.423)",
    fill: "none",
    stroke: "#5f2b7a",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    y1: 2.871,
    x2: 1.96,
    transform: "translate(21.821 33.533)",
    fill: "none",
    stroke: "#5f2b7a",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    "data-name": "Line 6",
    x2: 0.808,
    y2: 0.86,
    transform: "translate(35.592 34.479)",
    fill: "none",
    stroke: "#5f2b7a",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    x1: 0.946,
    y2: 1.1,
    transform: "translate(18.177 38.915)",
    fill: "none",
    stroke: "#5f2b7a",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M145.618,156.884a1.116,1.116,0,0,1-1.1,1.135,1.165,1.165,0,0,1-1.117-1.186,1.108,1.108,0,0,1,1.117-1.135,1.174,1.174,0,0,1,1.1,1.186",
    transform: "translate(-118.742 -128.904)",
    fill: "#5f2b7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M147.372,159.267a.614.614,0,0,1-.636.636.665.665,0,0,1-.636-.671.614.614,0,0,1,.636-.636.665.665,0,0,1,.636.671",
    transform: "translate(-120.978 -131.304)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M266.223,142.8h6.636l-.12.671-1.358.172c-.533.069-.55.1-.756,1.186l-2.183,12.413c-.189,1.083-.172,1.118.309,1.186l1.307.172-.12.671H263.3l.12-.671,1.358-.172c.533-.069.55-.1.756-1.186l2.183-12.413c.189-1.083.172-1.117-.31-1.186l-1.307-.172Z",
    transform: "translate(-218.028 -118.224)",
    fill: "#5f2b7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M324.755,172.935c-.671,3.559-2.888,5.639-6.327,5.639-3.542,0-5.278-2.888-4.573-6.619l.1-.516c.671-3.559,2.888-5.639,6.31-5.639,3.593,0,5.33,2.906,4.608,6.619Zm-4.47-6.292c-1.668,0-2.768,1.375-3.353,4.556l-.275,1.479c-.653,3.662.172,5.037,1.7,5.037,1.7,0,2.785-1.375,3.353-4.556l.275-1.479c.67-3.645-.155-5.037-1.7-5.037",
    transform: "translate(-259.764 -137.27)",
    fill: "#5f2b7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M387.539,142.8h13.324l-.722,4.161h-.67l-.309-2.682c-.052-.636-.052-.636-1.186-.636h-2.441l-2.407,13.6c-.189,1.083-.172,1.118.309,1.186l1.307.172-.12.671h-6.636l.12-.671,1.358-.172c.533-.069.55-.1.756-1.186l2.407-13.6h-2.441c-1.135,0-1.135,0-1.427.636l-1.238,2.682H386.8Z",
    transform: "translate(-320.296 -118.224)",
    fill: "#5f2b7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M471.518,159.37H464.4l.12-.67,1.358-.172c.516-.069.55-.1.756-1.186l2.183-12.413c.189-1.083.172-1.117-.309-1.186l-1.307-.172.12-.67h11.484l-.722,4.161h-.671l-.31-2.682c-.069-.585-.052-.636-1.186-.636h-3.971l-1.238,7.032h2.527c1.135,0,1.135-.052,1.41-.636l.877-1.96h.671l-1.049,6.035h-.67l-.189-1.96c-.052-.585-.069-.636-1.2-.636h-2.493l-1,5.725c-.189,1.083-.172,1.135.309,1.186l1.788.172Z",
    transform: "translate(-384.555 -118.307)",
    fill: "#5f2b7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M543.8,141.2h4.659l-1.5,8.648c-.4,2.287-.4,2.785.1,2.785.464,0,1.014-.464,1.427-1.7l.946.533a3.226,3.226,0,0,1-3.009,2.132c-1.771,0-2.682-1.307-2.3-3.559l1.186-6.808c.189-1.083.172-1.118-.309-1.186l-1.307-.172Zm2.252-3.576a1.732,1.732,0,0,1,1.788-1.822,1.356,1.356,0,0,1,1.5,1.461,1.732,1.732,0,0,1-1.788,1.822,1.373,1.373,0,0,1-1.5-1.461",
    transform: "translate(-450.221 -112.427)",
    fill: "#5f2b7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M579.2,183.814c-2.562,0-3.679-1.41-3.61-3.507l1.375-.344c-.138,2.235.774,3.06,2.183,3.06,1.908,0,3.2-1.169,3.8-4.573l.292-1.616a3.909,3.909,0,0,1-3.352,1.84c-2.974,0-4.264-2.974-3.593-6.688l.1-.533c.653-3.61,3.077-5.553,5.725-5.553a3.5,3.5,0,0,1,2.854,1.255,6.758,6.758,0,0,0,2.252-1.014h.653l-2.115,12.052c-.533,2.957-2.476,5.622-6.567,5.622m1.307-6.155c.653,0,1.943-.481,3.146-3.2l1.066-6.086a2.437,2.437,0,0,0-2.287-1.53c-1.719,0-2.544,1.616-3.009,4.3L579.2,172.4c-.585,3.576.052,5.261,1.307,5.261",
    transform: "translate(-476.622 -137.352)",
    fill: "#5f2b7a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo2.8c3a807e91c03f51cedd8f500c625a65.svg";
export { ForwardRef as ReactComponent };